/*<!-- Showing variants available before selecting them - P3MQA-14307 -Nico -->*/

(function () {
  const DEBUG = false;
  const S = {
    section: 'section[data-section-type="product"]',
    form: 'form.product-form',
    optionGroup: '.product-form__option[data-selector-type]',
    input: '.product-form__single-selector',
    radio: 'input[type="radio"].product-form__single-selector',
    select: 'select.product-form__single-selector',
    label: '.block-swatch__item, .color-swatch__item, .variant-swatch__item',
    wrap:  '.block-swatch, .color-swatch, .variant-swatch',
    disabledCls: ['block-swatch--disabled','color-swatch--disabled','variant-swatch--disabled'],
    atc: '.product-form__add-button'
  };
  const log = (...a)=>DEBUG&&console.log('[p3]',...a);

  function boot(){ document.querySelectorAll(S.section).forEach(init); }

  function init(section){
    if (section.dataset.p3Init === '1') return;

    // Only run for products with 2+ option groups
    const groups = section.querySelectorAll(S.optionGroup);
    if (groups.length < 2) { log('skip (0/1 option)'); return; }

    section.dataset.p3Init = '1';

    // Save original ATC label
    const atc = section.querySelector(S.atc);
    if (atc && !atc.dataset.p3OriginalLabel) {
      atc.dataset.p3OriginalLabel = (atc.textContent || '').trim();
    }

    const state = { preselect:true, variant:null };

    unlockAll(section);
    bridgeClicks(section, state);
    hookChanges(section, state);
    guardSubmit(section, state);
    enforceATC(section, state);
  }

  function unlockAll(root){
    root.querySelectorAll(`.${S.disabledCls[0]}, .${S.disabledCls[1]}, .${S.disabledCls[2]}`)
      .forEach(el=>el.classList.remove(...S.disabledCls));
    root.querySelectorAll(S.radio).forEach(r=>{ r.checked=false; });
    root.querySelectorAll(S.select).forEach(sel=>{
      if(!sel.querySelector('option[data-p3-ph]')){
        const opt=document.createElement('option');
        opt.value=''; opt.disabled=true; opt.hidden=true; opt.selected=true;
        opt.textContent='Select an option'; opt.setAttribute('data-p3-ph','1');
        sel.insertBefore(opt, sel.firstChild);
      } else sel.value='';
    });
    log('unlocked all swatches');
  }

  function bridgeClicks(root, state){
    root.addEventListener('click',(e)=>{
      const label = e.target.closest(S.label);
      if (!label) return;

      // Only block clicking disabled swatches AFTER all options are chosen
      if (!state.preselect) {
        const w = label.closest(S.wrap);
        if (w && S.disabledCls.some(c=>w.classList.contains(c))) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          log('blocked click on disabled swatch');
          return;
        }
      }

      // Let native label→radio happen, then ensure a change event fires
      const id = label.getAttribute('for');
      const input = id ? document.getElementById(id) : label.previousElementSibling;
      if (!input || input.disabled) return;
      setTimeout(()=>input.dispatchEvent(new Event('change',{bubbles:true})),0);
    }, false);
  }

  function hookChanges(root, state){
    const afterThemeUpdates = ()=>{
      // While preselecting, keep the user-chosen value visible (not crossed out)
      if (state.preselect) keepChosenVisible(root);
      enforceATC(root, state);
    };

    root.addEventListener('change',(e)=>{
      if(!e.target.matches(S.input)) return;
      // Stay in preselect mode until ALL option groups are chosen
      state.preselect = !allChosen(root);
      // Run after the theme’s own change handlers
      requestAnimationFrame(afterThemeUpdates);
    }, true);

    root.addEventListener('variant:changed',(e)=>{
      state.variant = e.detail && e.detail.variant ? e.detail.variant : null;
      requestAnimationFrame(afterThemeUpdates);
    });
  }

  function keepChosenVisible(root){
    root.querySelectorAll(S.optionGroup).forEach(group=>{
      const checked = group.querySelector(`${S.radio}:checked`);
      if (checked) {
        const w = checked.closest(S.wrap);
        if (w) w.classList.remove(...S.disabledCls);
      }
    });
  }

  function guardSubmit(root, state){
    const form = root.querySelector(S.form);
    if(!form) return;
    form.addEventListener('submit',(e)=>{
      if(!isATCAllowed(root, state)){
        e.preventDefault(); e.stopPropagation();
        log('blocked form submit');
      }
    }, true);
  }

  function allChosen(root){
    const groups = root.querySelectorAll(S.optionGroup);
    for (const g of groups){
      if (g.querySelector(`${S.radio}:checked`)) continue;
      const sel = g.querySelector(S.select);
      if (sel && sel.value) continue;
      return false;
    }
    return true;
  }

  function isATCAllowed(root, state){
    const chosen = allChosen(root);
    const available = !!(state.variant && state.variant.available);
    return chosen && available;
  }

  function setATCLabelForSelect(atc, enable){
    const original = atc.dataset.p3OriginalLabel || 'Add to cart';
    if (!enable) {
      if ((atc.textContent || '').trim() !== 'Select Options') {
        atc.dataset.p3PrevLabel = (atc.textContent || '').trim();
      }
      atc.textContent = 'Select Options';
    } else {
      if ((atc.textContent || '').trim() === 'Select Options') {
        atc.textContent = original;
      }
    }
  }

  function enforceATC(root, state){
    const atc = root.querySelector(S.atc);
    if(!atc) return;

    const chosen = allChosen(root);
    const available = !!(state.variant && state.variant.available);
    const allow = chosen && available;

    if (allow) {
      if (atc.disabled){ atc.disabled=false; atc.classList.remove('button--disabled'); }
    } else {
      if (!atc.disabled){ atc.disabled=true; atc.classList.add('button--disabled'); }
    }

    if (!chosen) setATCLabelForSelect(atc, false);
    else setATCLabelForSelect(atc, true);

    log('ATC enabled?', allow, '| chosen:', chosen, '| available:', available);
  }

  document.addEventListener('DOMContentLoaded', ()=>{ requestAnimationFrame(boot); setTimeout(boot,0); });
  document.addEventListener('shopify:section:load', boot);
})();
